"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
require("./styles.css");
var brandcenter_asset_filter_control_1 = __importDefault(require("@rotaryintl/brandcenter-asset-filter-control"));
var AssetPagination_1 = __importDefault(require("@component/AssetPagination"));
// let pageSize = 10;
function SiteTabSearchResults(_a) {
    var filterSummary = _a.filterSummary, siteTabItems = _a.siteTabItems, pageSize = _a.pageSize, pageLabel = _a.pageLabel, pageChange = _a.pageChange, currentPage = _a.currentPage, noResultText = _a.noResultText;
    var firstPageIndex = (currentPage - 1) * pageSize;
    var lastPageIndex = firstPageIndex + pageSize;
    var onPageChange = function (page) {
        pageChange(page);
    };
    var totallength = siteTabItems === null || siteTabItems === void 0 ? void 0 : siteTabItems.length;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "site_tab_search_results_container" }, { children: [(0, jsx_runtime_1.jsx)(brandcenter_asset_filter_control_1.default, { filterSummary: filterSummary }), siteTabItems && (siteTabItems === null || siteTabItems === void 0 ? void 0 : siteTabItems.length) > 0 ? (siteTabItems
                .map(function (item, idx) {
                return ((0, jsx_runtime_1.jsx)("div", { className: "site_tab_search_results_block", dangerouslySetInnerHTML: { __html: item } }, idx));
            })
                .slice(firstPageIndex, lastPageIndex)) : ((0, jsx_runtime_1.jsx)("div", { className: "richtext", dangerouslySetInnerHTML: { __html: noResultText } })), (0, jsx_runtime_1.jsx)(AssetPagination_1.default, { pageLabel: pageLabel, onPageChange: onPageChange, pageSize: pageSize, currentPage: currentPage, totalCount: (siteTabItems === null || siteTabItems === void 0 ? void 0 : siteTabItems.length) || 0 })] })));
}
exports.default = SiteTabSearchResults;
//# sourceMappingURL=index.js.map